import { Component } from '@angular/core';
import { StatsService } from 'src/app/core/services/stats.service';

@Component({
  selector: 'app-nif-by-secundary',
  templateUrl: './nif-by-secundary.component.html',
  styleUrls: ['./nif-by-secundary.component.scss']
})
export class NifBySecundaryComponent {

  loading: boolean;
  mostrarError: boolean;
  mostrarListado: boolean;

  datosInforme = []; //Para el listado de Numero de usos de NIfs por secundario

  constructor( private statsService: StatsService ) {
    this.loading = false;
    this.mostrarError = false;
    this.mostrarListado = false;
  }

  VisualizarDatos(principal: string, secundario: string) {
    if (principal == "" && secundario == "") {
      alert("Se debe de indicar al menos un principal o un secundario");
      return;
    }
    
    this.loading = true;
    this.mostrarListado = false;
    this.mostrarError = false;
    this.datosInforme = [];

    if (principal == "") {
      principal = "vacio";
    }

    this.statsService.obtenerListadoNumeroDocumentosNifSecundario(principal, secundario).subscribe(datos => {
      this.datosInforme = datos;

      this.mostrarListado = true;
      this.loading = false;
    }, ( error ) => {
      this.loading = false;
      this.mostrarError = true;
    });
  }

  SumarLinea(i: number, j: number): number {
    return this.datosInforme[i].nifs[j].documentosEmitidas + this.datosInforme[i].nifs[j].documentosRecibidas;
  }

}
